import React from 'react'

export const Input = ({label, type, name, id, autoComplete, placeholder, value, onChange}) => {
    return (
        <div>
            <label htmlFor="full-name" className="sr-only">
                {label}
            </label>
            <input
                type={type}
                name={name}
                id={id}
                autoComplete={autoComplete}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                className="block w-full shadow-sm py-3 px-4 focus:opacity-100 focus:ring-yellow focus:border-yellow rounded-md placeholder-lightGrey text-white"
                style={{ backgroundColor: "#B24E2F" }}
            />
        </div>
    )
}